const baseUrlMapping = {
  localhost: 'http://localhost:4326/mf-manifest.json',
  'simplify.developers.telus.digital':
    'https://assets.wcpreview.telus.com/1100769639/simplify-video-library/v1/mf2/mf-manifest.json',
  'simplify.staging.developers.telus.digital':
    'https://assets.wcstage.telus.com/1100769639/simplify-video-library/v1/mf2/mf-manifest.json',
  'simplify.telus.com':
    'https://assets.telus.com/1100769639/simplify-video-library/v1/mf2/mf-manifest.json',
};

export const videoLibrary = {
  remote: 'simplify_hub_video_library_mfe',
  name: 'video-library',
  source: 'https://github.com/telus/simplify-mfe-shell',
  urlMapping: baseUrlMapping,
};

export default videoLibrary;
